// ----------------------------------------------------------------------------
// Template: Collection
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/card/card';
import 'snippets/pagination/pagination';
import 'sections/powertools-filter/powertools-filter';

import 'sections/page-header/page-header';
import 'sections/footer/footer';


// Styles
import './_collection.scss';

document.addEventListener('DOMContentLoaded', function () {
    var productsOnPage = document.querySelector('.products-onpage');
    var nextUrl = productsOnPage.dataset.nextUrl;

    var loadMoreBtn = document.querySelector('.load-more_btn');
    var originalBtnText = loadMoreBtn.textContent; // Save the original button text

    function loadMoreProducts() {
        loadMoreBtn.textContent = 'Loading...';
        loadMoreBtn.style.pointerEvents = 'none'; // Disable button clicks during loading

        // Simulate delay before sending the actual request
        setTimeout(function() {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', nextUrl, true);

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status === 200) { // done equivalent
                    var parser = new DOMParser();
                    var nextPage = parser.parseFromString(xhr.responseText, 'text/html');
                    var newProducts = nextPage.querySelector('.products-onpage');
                    var newUrl = newProducts.dataset.nextUrl;

                    if (newUrl) {
                        loadMoreBtn.style.display = 'block';
                        loadMoreBtn.textContent = originalBtnText; // Revert the button text
                    } else {
                        loadMoreBtn.style.display = 'none'; // Hide button if no more products
                    }

                    nextUrl = newUrl;

                    productsOnPage.insertAdjacentHTML('beforeend', newProducts.innerHTML);
                }
            };

            xhr.send();
        }, 500); // 1-second delay before sending the request

        // Optional: Re-enable button if request fails or completes
        setTimeout(function() {
            loadMoreBtn.style.pointerEvents = 'auto'; // Re-enable button clicks
        }, 500); // Delay matches the delay before the actual request
    }

    // Attach the click event listener to the load more button
    loadMoreBtn.addEventListener('click', loadMoreProducts);
});
